import { cva } from "class-variance-authority";
import React from "react";
import { cn } from "@/shared/utils/shadcn";

interface TextComponentProps
  extends Omit<React.HTMLAttributes<HTMLParagraphElement>, "size"> {
  visible?: boolean;
  size?: "small" | "medium" | "large" | "xsmall";
  color?:
    | "grey"
    | "lightGrey"
    | "primary"
    | "warning"
    | "danger"
    | "success"
    | "white";
}

const subtitleTextStyles = cva("text-sm not-prose", {
  variants: {
    size: {
      xsmall: "text-2xs",
      small: "text-xs",
      medium: "text-sm",
      large: "text-lg",
    },
    color: {
      grey: "text-grey-600",
      lightGrey: "text-grey-400",
      primary: "text-primary",
      warning: "text-orange-500",
      danger: "text-red-500",
      success: "text-green-500",
      white: "text-white",
    },
  },
  defaultVariants: {
    size: "medium",
    color: "grey",
  },
});

export function ErrorText(props: TextComponentProps) {
  const { children, className, visible = true, ...rest } = props;

  if (!visible) return null;

  const classes = cn(
    "text-red-500 border-l-2 border-solid border-red-500 px-2 text-sm",
    className
  );
  return (
    <p className={classes} {...rest}>
      {children}
    </p>
  );
}

export function SubtitleText(props: TextComponentProps) {
  const { children, className, visible = true, size, color, ...rest } = props;

  if (!visible) return null;

  const classes = subtitleTextStyles({ size, color, className });

  return (
    <p className={classes} {...rest}>
      {children}
    </p>
  );
}
